import __request__ from "routing/request";
export function simulate(simulation, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/simulate", simulation, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
